// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.LandbotLivechat:not(.is-open) {\n  width: 55px !important;\n  height: 55px !important;\n  min-width: 55px !important;\n  min-height: 55px !important;\n  max-width: 55px !important;\n  max-height: 55px !important;\n  overflow: hidden !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
